import React from 'react'
import { useHistory } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Eye as EyeIcon } from 'react-feather'
import { reverse } from 'named-urls'
import PropTypes from 'prop-types'
import { Box, Chip, IconButton } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

import helpers from 'helpers'

import { routes } from 'Routes'

import useStyles from './styles'

const TableRowTicket = ({ ticket, refresh, handleChange, ...rest }) => {
  const history = useHistory()
  const classes = useStyles()
  const theme = useTheme()

  const navigateToEdit = (ticketId) => {
    history.push(
      reverse(routes.technicalFaqs.tickets.details, {
        ticketId: ticketId,
      }),
    )
  }

  return (
    <TableRow
      className={classes.clickableRow}
      onClick={() => navigateToEdit(ticket?.id)}
      {...rest}
    >
      <TableCell>{ticket?.id}</TableCell>
      <TableCell>{ticket?.title}</TableCell>
      <TableCell>{ticket?.subtitle || '-'}</TableCell>
      <TableCell>{ticket?.user?.name}</TableCell>
      <TableCell align="center">
        {helpers.formatters.ptBrFormatDateTime(ticket?.createdAt)}
      </TableCell>
      <TableCell align="center">
        {helpers.formatters.ptBrFormatDateTime(ticket?.updatedAt)}
      </TableCell>
      <TableCell align="center">
        <Chip
          label={ticket?.status?.name || 'Não definido'}
          size="small"
          className={classes.statusChip}
          style={{
            backgroundColor:
              ticket?.status?.color || theme.palette.custom.disabled,
            color: ticket?.status?.textColor || theme.palette.white,
          }}
        />
      </TableCell>
      <TableCell align="center" onClick={(event) => event.stopPropagation()}>
        <Box>
          <IconButton onClick={() => navigateToEdit(ticket?.id)}>
            <EyeIcon size={18} />
          </IconButton>
        </Box>
      </TableCell>
    </TableRow>
  )
}

const TicketTable = ({ ticketData, isLoading, refresh }) => {
  return (
    <>
      <Box width="100%">
        <PerfectScrollbar
          options={{
            useBothWheelAxes: true,
            suppressScrollX: false,
          }}
        >
          <Table
            size="medium"
            emptyMessage="Nenhuma solicitação encontrada"
            isLoading={isLoading}
            noWrap
          >
            <TableHead>
              <TableRow>
                <TableCell width="5%">ID</TableCell>
                <TableCell width="20%">Categoria</TableCell>
                <TableCell width="20%">Título</TableCell>
                <TableCell width="16%">Solicitante</TableCell>
                <TableCell width="12%" align="center">
                  Data de Criação
                </TableCell>
                <TableCell width="12%" align="center">
                  Ultima interação
                </TableCell>
                <TableCell width="10%" align="center">
                  Status
                </TableCell>
                <TableCell width="5%" align="center">
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ticketData?.tickets.map((ticket) => (
                <TableRowTicket
                  ticket={ticket}
                  key={ticket?.id}
                  refresh={refresh}
                  hover
                />
              ))}
            </TableBody>
          </Table>
        </PerfectScrollbar>
      </Box>
    </>
  )
}

TicketTable.propTypes = {
  ticketData: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  refresh: PropTypes.func,
}

TableRowTicket.propTypes = {
  ticket: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
  refresh: PropTypes.func,
}

TicketTable.defaultProps = {
  refresh: () => {},
  isLoading: false,
}

TableRowTicket.defaultProps = {
  handleChange: () => {},
  refresh: () => {},
}

export default TicketTable
